import { createElementBlock as e, openBlock as o, createElementVNode as r } from "vue";
import n from "./index289.js";
const a = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, p, m, f, i) {
  return o(), e("svg", l, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M15.75 14.25a5 5 0 0 1 4.995 4.783l.005.217V20a.75.75 0 0 1-1.493.102L19.25 20v-.75a3.5 3.5 0 0 0-3.308-3.495l-.192-.005h-7.5a3.5 3.5 0 0 0-3.495 3.308l-.005.192V20a.75.75 0 0 1-1.493.102L3.25 20v-.75a5 5 0 0 1 4.783-4.995l.217-.005h7.5ZM12 2.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Zm0 1.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(a, [["render", s]]);
export {
  u as default
};
